<template>
  <v-pagination
    v-if="totalPages > 1"
    v-model="page"
    :class="{ 'disabled-prev': page == 1, 'disabled-next': page == totalPages }"
    :pages="totalPages"
    :range-size="1"
    :hide-first-button="true"
    :hide-last-button="true"
    @update:model-value="pageChanged" />
</template>

<script>
import VPagination from '@hennge/vue3-pagination'

export default {
  components: {
    VPagination,
  },

  props: {
    resultsCount: {
      type: Number,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
  },
  emits: ['page-changed'],
  data() {
    return {
      page: 1,
    }
  },

  computed: {
    totalPages() {
      return Math.ceil(this.resultsCount / this.pageSize)
    },
  },

  methods: {
    pageChanged() {
      this.$emit('page-changed', this.page)      
    },
  },
}
</script>
